// Attendre que le DOM soit complètement chargé
(function() {
  'use strict';
  
  // ===== DÉTECTION ET APPLICATION DE LA SAISON =====
  function setSeason() {
    const now = new Date();
    const month = now.getMonth() + 1; // 1-12
    let season = 'autumn'; // Par défaut automne
    let decorations = [];
    
    console.log('Mois actuel:', month); // Debug
    
    // Déterminer la saison et les décorations
    if (month >= 3 && month <= 5) {
      // Printemps (Mars - Mai)
      season = 'spring';
      decorations = ['🌸', '🦋', '🌼', '🌷', '🐝'];
    } else if (month >= 6 && month <= 8) {
      // Été (Juin - Août)
      season = 'summer';
      decorations = ['☀️', '🌊', '🏖️', '🍉', '🦜'];
    } else if (month >= 9 && month <= 11) {
      // Automne (Septembre - Novembre)
      season = 'autumn';
      decorations = ['🍂', '🍁', '🌰', '🍄', '🦔'];
    } else {
      // Hiver (Décembre - Février)
      season = 'winter';
      decorations = ['❄️', '⛄', '🎄', '🌟', '☃️'];
    }
    
    console.log('Saison détectée:', season); // Debug
    console.log('Décorations:', decorations); // Debug
    
    // Appliquer l'attribut de saison au body
    document.body.setAttribute('data-season', season);
    
    // Ajouter les décorations flottantes
    addSeasonalDecorations(decorations);
  }
  
  // ===== AJOUTER LES DÉCORATIONS FLOTTANTES =====
function addSeasonalDecorations(decorations) {
  // Supprimer les anciennes décorations
  document.querySelectorAll('.seasonal-decoration').forEach(el => el.remove());
  
  console.log('Ajout de 10 décorations avec positions fixes'); // Debug
  
  // Positions fixes pour chaque décoration (10 maintenant !)
  const positions = [
    { top: '10%', left: '5%', delay: '0s', duration: '28s' },
    { top: '15%', right: '8%', delay: '3s', duration: '25s' },
    { top: '25%', left: '15%', delay: '6s', duration: '30s' },
    { top: '35%', right: '12%', delay: '9s', duration: '27s' },
    { top: '50%', left: '8%', delay: '12s', duration: '32s' },
    { top: '55%', right: '15%', delay: '15s', duration: '26s' },
    { top: '65%', left: '18%', delay: '18s', duration: '29s' },
    { top: '70%', right: '6%', delay: '21s', duration: '31s' },
    { top: '85%', left: '10%', delay: '24s', duration: '28s' },
    { top: '90%', right: '20%', delay: '27s', duration: '33s' }
  ];
  
  // Créer 10 décorations
  for (let i = 0; i < 10; i++) {
    const decoration = document.createElement('div');
    decoration.className = 'seasonal-decoration';
    decoration.textContent = decorations[Math.floor(Math.random() * decorations.length)];
    
    // Appliquer les positions et animations directement via style inline
    const pos = positions[i];
    decoration.style.cssText = `
      position: absolute;
      top: ${pos.top};
      ${pos.left ? 'left: ' + pos.left : 'right: ' + pos.right};
      font-size: 2.5em;
      opacity: 0.4;
      pointer-events: none;
      z-index: 1;
      animation: float ${pos.duration} infinite ease-in-out;
      animation-delay: ${pos.delay};
    `;
    
    document.body.appendChild(decoration);
    console.log(`Décoration ${i+1} ajoutée:`, decoration.textContent, pos); // Debug
  }
}
  
  // ===== INITIALISATION =====
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      console.log('DOM chargé, initialisation...'); // Debug
      setSeason();
      initOtherFeatures();
    });
  } else {
    console.log('DOM déjà chargé, initialisation immédiate...'); // Debug
    setSeason();
    initOtherFeatures();
  }
  
  // ===== AUTRES FONCTIONNALITÉS =====
  function initOtherFeatures() {
    
    // Animation au scroll pour les cartes
    const observerOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -50px 0px'
    };

    const observer = new IntersectionObserver(function(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'translateY(0)';
        }
      });
    }, observerOptions);

    document.querySelectorAll('.card').forEach(card => {
      card.style.opacity = '0';
      card.style.transform = 'translateY(20px)';
      card.style.transition = 'opacity 0.6s ease, transform 0.6s ease';
      observer.observe(card);
    });
    
    // Mise à jour du compteur de panier
    function updateCartCount() {
      fetch('/cart.js')
        .then(response => response.json())
        .then(cart => {
          const cartLinks = document.querySelectorAll('a[href="/cart"]');
          cartLinks.forEach(link => {
            if (link.textContent.includes('Panier')) {
              link.textContent = `Panier (${cart.item_count})`;
            }
          });
        })
        .catch(error => console.log('Erreur cart:', error));
    }
    
    // Confirmation d'ajout au panier
    document.addEventListener('submit', function(e) {
      if (e.target.action && e.target.action.includes('/cart/add')) {
        setTimeout(() => {
          updateCartCount();
          const message = document.createElement('div');
          message.innerHTML = '✅ Produit ajouté au panier !';
          message.style.cssText = 'position:fixed;top:20px;right:20px;background:#4CAF50;color:white;padding:15px 20px;border-radius:8px;z-index:10000;font-weight:600;box-shadow:0 4px 12px rgba(0,0,0,0.2);';
          document.body.appendChild(message);
          setTimeout(() => message.remove(), 3000);
        }, 500);
      }
    });
    
    // Amélioration UX pour les formulaires
    const forms = document.querySelectorAll('form');
    forms.forEach(form => {
      const submitBtn = form.querySelector('button[type="submit"], input[type="submit"]');
      if (submitBtn) {
        form.addEventListener('submit', function() {
          submitBtn.disabled = true;
          const originalText = submitBtn.textContent;
          submitBtn.textContent = 'Ajout en cours...';
          
          setTimeout(() => {
            submitBtn.disabled = false;
            submitBtn.textContent = originalText;
          }, 2000);
        });
      }
    });

    // Smooth scroll pour les liens internes
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
      anchor.addEventListener('click', function (e) {
        e.preventDefault();
        const target = document.querySelector(this.getAttribute('href'));
        if (target) {
          target.scrollIntoView({
            behavior: 'smooth',
            block: 'start'
          });
        }
      });
    });
  }
  
})();